import { useState, useEffect } from 'react'

/**
 * Custom hook for responsive media query matching
 * @param query - CSS media query string (e.g., "(max-width: 767px)")
 * @returns boolean indicating if the media query matches
 */
export function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState(false)

	useEffect(() => {
		const media = window.matchMedia(query)

		// Set initial value
		setMatches(media.matches)

		// Create listener
		const listener = (e: MediaQueryListEvent) => {
			setMatches(e.matches)
		}

		// Add listener (use addEventListener for better compatibility)
		media.addEventListener('change', listener)

		// Cleanup
		return () => {
			media.removeEventListener('change', listener)
		}
	}, [query])

	return matches
}
